// PostsSection.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { Plus, List } from 'lucide-react';

import PostCard from './components/PostCard';

import { uploadImage, fetchImage } from "utils/images/imageManager";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";


const PostsSection = ({ t, myInfoPosts, imageMap }) => {

  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (

    <div className="d-block">
      <Row>
        <Col className="info-profile-carousel-col">
          <div className="d-flex flex-column">
            <div style={{ paddingLeft: "25px", marginBottom: "10px" }}>
              <p className="mb-0 info-profile-section-title">所有貼文</p>
            </div>

            <div style={{ padding: "0px 20px"}}>
              {myInfoPosts.map((post, idx) => (
                <PostCard 
                  key={idx} 
                  post={post} 
                  imageMap={imageMap}
                />
              ))}
            </div>

          </div>
        </Col>
      </Row>

    </div>

  );
};

export default withTranslation()(PostsSection);


